import { privateTasksManager } from '@inpart-io/padme-iap';
import { type NavigationGuardNext, type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

import { LeadOverviewTabKeys } from './constants/lead-overview.constants';

const LeadOverviewPage = (): unknown => {
    return import(/* webpackPrefetch: true */ '@/pages/lead-overview/lead-overview-page.vue');
};

export const leadOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.LEAD_OVERVIEW_PAGE,
    components: {
        main: LeadOverviewPage
    },
    props: {
        main(route: RouteLocationNormalized): { leadId?: number } {
            return { leadId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};

const TaskOverviewPage = (): unknown => {
    return import(/* webpackPrefetch: true */ '@/pages/lead-overview/components/lead-tasks/lead-tasks.vue');
};

export const taskOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.TASK_OVERVIEW_PAGE,
    beforeEnter: async (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> => {
        const task = await privateTasksManager.getById(parseInt(to.params.id as string, 10), { properties: 'mainLink.onLead' });
        next({
            name: ROUTE_DATA.LEAD_OVERVIEW_PAGE.name,
            params: { id: task.mainLink.onLead },
            query: { leadTab: LeadOverviewTabKeys.OVERVIEW_KEY, openTasks: 'true' }
        });
    },
    components: {
        main: TaskOverviewPage
    }
};
